import { make } from 'vuex-pathify';
import initialState from './state';

export default {
    ...make.getters(initialState),

    showDeleteVenueModal: state => state.deleteVenueId !== null,
};
